
import { Link } from "react-router-dom";

const subTitle = "Services";
const title = "What We Do";


const categoryList = [
    {
        imgUrl: 'assets/images/category/icon/agreement.png',
        imgAlt: 'category rajibraj91 rajibraj',
        title: 'Admission Process',
        desc: '24 Course',
    },
    {
        imgUrl: 'assets/images/category/icon/interview.png',
        imgAlt: 'category rajibraj91 rajibraj',
        title: 'Interview preparation',
        desc: '63 Course',
    },
    {
        imgUrl: 'assets/images/category/icon/test.png',
        imgAlt: 'category rajibraj91 rajibraj',
        title: 'University entrance test',
        desc: '43 Course',
    },
    {
        imgUrl: 'assets/images/category/icon/online-learning.png',
        imgAlt: 'category rajibraj91 rajibraj',
        title: 'Course assessment',
        desc: '50 Course',
    },
    {
        imgUrl: 'assets/images/category/icon/support.png',
        imgAlt: 'category rajibraj91 rajibraj',
        title: 'Free Customer services',
        desc: '27 Course',
    },
    {
        imgUrl: 'assets/images/category/icon/advisor.png',
        imgAlt: 'category rajibraj91 rajibraj',
        title: 'Free Education Counselling',
        desc: '87 Course',
    },
    {
        imgUrl: 'assets/images/category/icon/visa.png',
        imgAlt: 'category rajibraj91 rajibraj',
        title: 'Visa Assistance',
        desc: '15 Course',
    },
    {
        imgUrl: 'assets/images/category/icon/departures.png',
        imgAlt: 'category rajibraj91 rajibraj',
        title: 'Pre-Post Departure Assistance',
        desc: '58 Course',
    },
    {
        imgUrl: 'assets/images/category/icon/accommodation.png',
        imgAlt: 'category rajibraj91 rajibraj',
        title: 'Accommodation Assistance',
        desc: '58 Course',
    },
    {
        imgUrl: 'assets/images/category/icon/degree.png',
        imgAlt: 'category rajibraj91 rajibraj',
        title: 'Scholarships',
        desc: '58 Course',
    },
]

const CategoryTwo = () => {
    return (
        <div className="category-section padding-tb section-bg style-2">
            <div className="container">
                <div className="section-header text-center">
                    <span className="subtitle">{subTitle}</span>
                    <h2 className="title">{title}</h2>
                </div>
                <div className="section-wrapper">
                    <div className="row g-4 justify-content-center row-cols-xl-4 row-cols-lg-3 row-cols-sm-2 row-cols-1">
                        {categoryList.map((val, i) => (
                            <div className="col" key={i}>
                                <div className="text-center bg-white box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px; rounded-lg p-4 transition-transform hover:scale-105">
                                    <div className=" flex w-[200px] h-[60px] flex-col items-center">
                                        <div className="category- w-full flex justify-center items-center">
                                            <img className="w-12 object-contain" src={val.imgUrl} alt={val.imgAlt} />
                                            <span className="text-sm text-gray-800">{val.title}</span>

                                        </div>
                                        {/* <div className="category-content mt-3 text-center">
                    <Link to="/course">
                        <h6 className="text-lg font-semibold text-gray-800">{val.title}</h6>
                    </Link>
                    <span className="text-sm text-gray-600">{val.desc}</span>
                </div> */}
                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>
                </div>
            </div>
        </div>
    );
}

export default CategoryTwo;